// Responsive helpers for the inline-styles (no-Tailwind) clinical portal.
// Breakpoint: phone < 768px ("narrow"), tablet-portrait and up >= 768px ("wide").
import { useEffect, useState } from "react";

function useMediaQuery(query) {
  const get = () =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false;
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    // Safari < 14 uses addListener/removeListener
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);
  return matches;
}

// True on phones (and very small windows). Use to switch layout to single-column,
// full-screen modals, card-style tables, etc.
export function useIsNarrow() {
  return useMediaQuery("(max-width: 767px)");
}

// True when the device/window is in portrait orientation. Used (with useIsNarrow)
// to prompt the user to rotate before signing.
export function useIsPortrait() {
  return useMediaQuery("(orientation: portrait)");
}
